import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import Region from "../../Utility/Crud/Region";

export default class ChipRegion extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color =
      this.props.region || this.props.hasSelection
        ? Region.getColor()
        : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {Region.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The region name.
   */
  getLabel() {
    if (this.props.region) {
      return this.props.labelPrefix
        ? `${this.props.labelPrefix}: ${Region.getDisplayName(this.props.region)}`
        : Region.getDisplayName(this.props.region);
    } else {
      return this.props.nullLabel || "None";
    }
  }
}
